import React from "react";

function Samsung() {
    return (
        <h1>
        This si the samsung page</h1>
    );
}

export default Samsung